import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_country_hdr_RowInterface {
    alpha3_code: fromDatatype.VarcharDatatypeInterface;
    alpha2_code: fromDatatype.VarcharDatatypeInterface;
    country_name: fromDatatype.VarcharDatatypeInterface;
    states_json: fromDatatype.JsonDatatypeInterface;
    prefix_json: fromDatatype.JsonDatatypeInterface;
    phone_code1: fromDatatype.IntegerDatatypeInterface;
    phone_code2: fromDatatype.IntegerDatatypeInterface;
    phone_code3: fromDatatype.IntegerDatatypeInterface;
}

export class bl_fi_country_hdr_RowClass implements bl_fi_country_hdr_RowInterface {
    alpha3_code: fromDatatype.VarcharDatatypeInterface;
    alpha2_code: fromDatatype.VarcharDatatypeInterface;
    country_name: fromDatatype.VarcharDatatypeInterface;
    states_json: fromDatatype.JsonDatatypeInterface;
    prefix_json: fromDatatype.JsonDatatypeInterface;
    phone_code1: fromDatatype.IntegerDatatypeInterface;
    phone_code2: fromDatatype.IntegerDatatypeInterface;
    phone_code3: fromDatatype.IntegerDatatypeInterface;
}
